import { OnInit, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { ReservationService } from '../../../services/reservation.service';
import { LogView } from '../../../model/log-view';


@Component({
  selector: 'app-log-view-dialog',
  templateUrl: 'log-view-dialog.component.html',
  styleUrls: ['./log-view-dialog.component.css']
})

export class LogViewDialogComponent implements OnInit {

  patientLogView: LogView[] = [];
  medicalAppointmentLogView: LogView[] = [];
  reportStudyLogView: LogView[] = [];
  referringPhysicianLogView: LogView[] = [];

  loading: boolean;

  constructor(private reservationService: ReservationService
    , private notificationToastService: NotificationToastService
    , public dialogRef: MatDialogRef<LogViewDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public medicalAppointmentId: number) {
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async ngOnInit() {
    await this.getObservations();
  }

  private async getObservations() {
    try {
      this.loading = true;
      const logViewInfo = await this.reservationService.getViewInfo(this.medicalAppointmentId);
      this.patientLogView = logViewInfo.PatientLogView;
      this.medicalAppointmentLogView = logViewInfo.MedicalAppointmentLogView;
      this.reportStudyLogView = logViewInfo.ReportStudyLogView;
      this.referringPhysicianLogView = logViewInfo.ReferringPhysicianLogView;
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Logs del turno');
    } finally {
      this.loading = false;
    }
  }
}
